import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
// Styles
import "./styles.css";
import styles from "./Modal.css";

ReactModal.setAppElement("#root");

class Modal extends Component {
  handleCloseModal = (event) => {
    const { closeModal } = this.props;

    if (event.target === event.currentTarget) {
      event.stopPropagation();
      return closeModal && closeModal();
    }
  };

  render() {
    const {
      cancelActionLabel,
      children,
      closeModal,
      confirmAction,
      confirmActionDisabled,
      confirmActionLabel,
      isOpen,
      shouldCloseOnOverlayClick,
      title
    } = this.props;

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={{ content: styles.content, overlay: styles.overlay }}
      >
        <div className="modal-header">
          <button
            aria-hidden="true"
            className="close"
            data-dismiss="modal"
            onClick={this.handleCloseModal}
            type="button"
          >
            &times;
          </button>
          <h4 className="modal-title" id="myModalLabel">
            {title}
          </h4>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          <button
            className="btn btn-default"
            data-dismiss="modal"
            onClick={this.handleCloseModal}
            type="button"
          >
            {cancelActionLabel}
          </button>
          <button
            className="btn btn-primary"
            disabled={confirmActionDisabled}
            onClick={confirmAction}
            type="button"
          >
            {confirmActionLabel}
          </button>
        </div>
      </ReactModal>
    );
  }
}

Modal.defaultProps = {
  confirmActionDisabled: false,
  shouldCloseOnOverlayClick: true
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
  confirmActionDisabled: PropTypes.bool,
  cancelActionLabel: PropTypes.string.isRequired,
  confirmActionLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  shouldCloseOnOverlayClick: PropTypes.bool,
  title: PropTypes.string.isRequired
};

export default Modal;
